import moment from 'moment-timezone';

import { getStarOfDay } from './dayCalculations';

/**
 * Range and week-window calculations.
 */

export const getDaysToUTCRangeMap = (fromTimestamp, toTimestamp, timezone, format = 'ddd') => {
	const dateRangeMap = new Map();
	const momentStart = getStarOfDay(fromTimestamp, timezone);
	const momentFinish = getStarOfDay(toTimestamp, timezone);
	while (momentStart <= momentFinish) {
		const currentMoment = moment(momentStart);
		dateRangeMap.set(currentMoment.format(), {
			date: currentMoment.format('MMM DD'),
			weekday: currentMoment.format(format),
			moment: currentMoment,
		});
		momentStart.add(1, 'd');
	}
	return dateRangeMap;
};

export const isDayInCurrentWeek = (day, timezone = moment.tz.guess()) => {
	const dayMoment = moment(day).tz(timezone);
	const currentDay = moment().tz(timezone);
	return moment(dayMoment).isSame(currentDay, 'week');
};

export const getBusinessWeekRange = (timezone = moment.tz.guess()) => {
	const now = moment.tz(timezone);
	const businessWeekStart = now.clone().startOf('isoWeek').startOf('day').toISOString();
	const businessWeekEnd = now.clone().endOf('isoWeek').endOf('day').toISOString();

	return {
		businessWeekStart,
		businessWeekEnd,
	};
};
